import { render, staticRenderFns } from "./RoundSelect.vue?vue&type=template&id=80cf1554&scoped=true&lang=pug&"
import script from "./RoundSelect.vue?vue&type=script&lang=ts&"
export * from "./RoundSelect.vue?vue&type=script&lang=ts&"
import style0 from "./RoundSelect.vue?vue&type=style&index=0&id=80cf1554&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cf1554",
  null
  
)

export default component.exports